import PropTypes from 'prop-types';
import InputField from '../InputField';
import getTargetAttribute from '../../services/getTargetAttribute';

const propTypes = {
    disabled: PropTypes.bool,
    errorMessage: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    /**
     * Phone number value
     */
    value: PropTypes.string,
};

const PhoneInputField = ({ disabled, errorMessage, label, onChange, value }) => {
    const handleChange = (newValue) => {
        // No alpha characters allowed (only numbers).
        if (newValue === '' || /^[0-9\b]+$/.test(newValue)) {
            onChange(newValue);
        }
    };

    return (
        <InputField
            label={label}
            value={value}
            onChange={handleChange}
            errorMessage={errorMessage}
            disabled={disabled}
            data-target={getTargetAttribute('phone-number-field')}
        />
    );
};

PhoneInputField.propTypes = propTypes;

export default PhoneInputField;
